// import { useState } from 'react'

// export default function RequestDemo() {
//   const [formData, setFormData] = useState({
//     name: '', email: '', company: '', phone: '', message: ''
//   })

//   const handleSubmit = (e) => {
//     e.preventDefault()
//     alert("Demo requested! We'll contact you soon 🚀")
//     console.log(formData)
//   }

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value })
//   }

//   return (
//     <div className="min-h-screen bg-gray-50 py-20">
//       <div className="max-w-3xl mx-auto px-4">
//         <h1 className="text-4xl md:text-5xl font-bold text-center mb-4">
//           Request a Free Demo
//         </h1>
//         <p className="text-xl text-gray-600 text-center mb-12">
//           See our platform in action. No commitment required.
//         </p>

//         <form onSubmit={handleSubmit} className="bg-white rounded-2xl shadow-xl p-10 space-y-6">
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-2">Full Name *</label>
//             <input type="text" name="name" required onChange={handleChange}
//               className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent" />
//           </div>

//           <div className="grid md:grid-cols-2 gap-6">
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">Work Email *</label>
//               <input type="email" name="email" required onChange={handleChange}
//                 className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500" />
//             </div>
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">Company</label>
//               <input type="text" name="company" onChange={handleChange}
//                 className="w-full px-4 py-3 border border-gray-300 rounded-lg" />
//             </div>
//           </div>

//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-2">Phone (optional)</label>
//             <input type="tel" name="phone" onChange={handleChange}
//               className="w-full px-4 py-3 border border-gray-300 rounded-lg" />
//           </div>

//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-2">Tell us about your project</label>
//             <textarea name="message" rows={5} onChange={handleChange}
//               className="w-full px-4 py-3 border border-gray-300 rounded-lg"></textarea>
//           </div>

//           <button type="submit"
//             className="w-full bg-indigo-600 text-white py-4 rounded-lg text-lg font-semibold hover:bg-indigo-700 transition transform hover:scale-105">
//             Request Demo →
//           </button>
//         </form>
//       </div>
//     </div>
//   )
// }

// src/pages/RequestDemo.js
import { useState } from 'react';
import {
  Shield, CheckCircle2, Users, Zap, Lock, AlertCircle, Loader2
} from 'lucide-react';

export default function RequestDemo() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    company: '',
    jobTitle: '',
    phone: '',
    industry: '',
    additionalInfo: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleIndustryChange = (e) => {
    setFormData({ ...formData, industry: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');

    // Simulate API call (replace with real endpoint later)
    try {
      // await fetch('/api/demo', { method: 'POST', body: JSON.stringify(formData) });
      const response = await fetch('/api/demo', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });

    const data = await response.json();

    if (!response.ok || !data.success) {
      // Worker returns { success: false, errors: [...] } on validation errors
      throw new Error(
        data.errors?.join(', ') || 'Failed to submit the form. Please try again.'
      );
    }

      setIsSubmitted(true);
      setFormData({
        firstName: '', lastName: '', email: '', company: '',
        jobTitle: '', phone: '', industry: '', additionalInfo: ''
      });
    } catch (err) {
      setError('Failed to submit. Please try again later.');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isSubmitted) {
    return (
      <div className="min-h-screen bg-gray-50 py-20">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <div className="w-20 h-20 bg-indigo-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <CheckCircle2 className="w-12 h-12 text-indigo-600" />
          </div>
          <h2 className="text-4xl font-bold mb-4">Thank You!</h2>
          <p className="text-xl text-gray-600 mb-8">
            Your demo request has been submitted successfully.<br />
            Our team will contact you within 24 hours.
          </p>
          <button
            onClick={() => setIsSubmitted(false)}
            className="px-8 py-3 border border-indigo-600 text-indigo-600 rounded-lg hover:bg-indigo-50 transition"
          >
            Submit Another Request
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-16">
      <div className="max-w-7xl mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="w-16 h-16 bg-indigo-600 rounded-full flex items-center justify-center mx-auto mb-6">
            <Shield className="w-10 h-10 text-white" />
          </div>
          <h1 className="text-5xl font-bold mb-4">Request a Demo</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            See how TigerTrust can transform your PKI and certificate management operations
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          {/* Form */}
          <div className="bg-white rounded-2xl shadow-xl p-8">
            <form onSubmit={handleSubmit} className="space-y-6">
              {error && (
                <div className="p-4 bg-red-50 border border-red-200 rounded-lg flex items-center">
                  <AlertCircle className="w-5 h-5 text-red-600 mr-3" />
                  <p className="text-red-700">{error}</p>
                </div>
              )}

              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-semibold mb-2">First Name *</label>
                  <input
                    name="firstName"
                    type="text"
                    required
                    value={formData.firstName}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none transition"
                    placeholder="John"
                  />
                </div>
                <div>
                  <label className="block text-sm font-semibold mb-2">Last Name *</label>
                  <input
                    name="lastName"
                    type="text"
                    required
                    value={formData.lastName}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none"
                    placeholder="Doe"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-semibold mb-2">Work Email *</label>
                <input
                  name="email"
                  type="email"
                  required
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none"
                  placeholder="john.doe@company.com"
                />
              </div>

              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-semibold mb-2">Company *</label>
                  <input
                    name="company"
                    type="text"
                    required
                    value={formData.company}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500"
                    placeholder="ACME Corp"
                  />
                </div>
                <div>
                  <label className="block text-sm font-semibold mb-2">Job Title *</label>
                  <input
                    name="jobTitle"
                    type="text"
                    required
                    value={formData.jobTitle}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500"
                    placeholder="Security Engineer"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-semibold mb-2">Phone Number</label>
                <input
                  name="phone"
                  type="tel"
                  value={formData.phone}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg"
                  placeholder="+1 (555) 123-4567"
                />
              </div>

              <div>
                <label className="block text-sm font-semibold mb-2">Industry *</label>
                <select
                  name="industry"
                  required
                  value={formData.industry}
                  onChange={handleIndustryChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none"
                >
                  <option value="">Select your industry</option>
                  <option value="financial">Financial Services</option>
                  <option value="healthcare">Healthcare</option>
                  <option value="automotive">Automotive</option>
                  <option value="telecom">Telecommunications</option>
                  <option value="manufacturing">Manufacturing / Industrial IoT</option>
                  <option value="retail">Retail / E-commerce</option>
                  <option value="technology">Technology / Software</option>
                  <option value="government">Government / Public Sector</option>
                  <option value="other">Other</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-semibold mb-2">Additional Information</label>
                <textarea
                  name="additionalInfo"
                  rows={4}
                  value={formData.additionalInfo}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500"
                  placeholder="Tell us more about your PKI challenges..."
                />
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-indigo-600 text-white py-4 rounded-lg font-semibold text-lg hover:bg-indigo-700 transition flex items-center justify-center disabled:opacity-70"
              >
                {isSubmitting ? (
                  <>
                    <Loader2 className="w-5 h-5 mr-3 animate-spin" />
                    Submitting...
                  </>
                ) : (
                  'Request Demo'
                )}
              </button>
            </form>
          </div>

          {/* Right Side - Benefits */}
          <div className="space-y-10">
            <div>
              <h2 className="text-3xl font-bold mb-6">What to Expect</h2>
              <p className="text-gray-600 mb-8">
                During your personalized demo, you'll discover how TigerTrust can help you:
              </p>

              <div className="space-y-6">
                {[
                  { icon: CheckCircle2, title: "Automate Certificate Lifecycle", desc: "Eliminate manual processes and reduce overhead by 80%" },
                  { icon: Zap, title: "Prevent Costly Outages", desc: "Proactive monitoring prevents certificate-related downtime" },
                  { icon: Lock, title: "Ensure Compliance", desc: "Meet regulations with audit trails and policy enforcement" },
                  { icon: Users, title: "Scale with Confidence", desc: "Manage millions of certificates across all environments" },
                ].map((item, i) => (
                  <div key={i} className="flex gap-4">
                    <div className="w-12 h-12 bg-indigo-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <item.icon className="w-6 h-6 text-indigo-600" />
                    </div>
                    <div>
                      <h3 className="font-bold text-lg">{item.title}</h3>
                      <p className="text-gray-600">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>

              <div className="mt-12 bg-gray-100 rounded-2xl p-8">
                <h3 className="font-bold text-xl mb-6">Join 1,500+ Enterprises Who Trust TigerTrust</h3>
                <div className="grid grid-cols-2 gap-6 text-center">
                  {[
                    { num: "95%", label: "Customer Retention" },
                    { num: "90%", label: "Support Satisfaction" },
                    { num: "4.6★", label: "G2 Rating" },
                    { num: "24h", label: "Response Time" },
                  ].map((stat, i) => (
                    <div key={i}>
                      <div className="text-4xl font-bold text-indigo-600">{stat.num}</div>
                      <div className="text-sm text-gray-600 mt-1">{stat.label}</div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="border-t pt-8 mt-8">
                <p className="text-gray-600">Prefer to speak directly?</p>
                <p className="text-2xl font-bold text-indigo-600">Call 1-800-TIGER-00</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}